export default {
  configuracionVuex: null
};
